<template>
  <!-- <div>
    <div><p><button @click="readst ('productDetailS',833)">读取单个数据</button></p></div>
   <p> <button @click="imageUrlToBase64(113,'https://hujiakj.oss-cn-shanghai.aliyuncs.com/167906181318710765.png')">图片转数据流</button></p>

   <div>{{msg}}</div>
   <div>{{network}}-{{msg}}-{{message}}</div>
   <div><p><button @click="dbOpen ()">打开数据库</button></p></div>
   <div><p><button @click="dbOpen ()">创建数据表</button></p></div>
   <div><p><button @click="addst ('user',dat)">添加数据</button></p></div>
   <div><p><button @click="update ('user',dat)">更新数据</button></p></div>
   <div><p><button @click="readst ('user','186884634')">读取单个数据</button></p></div>
   <div><p><button @click="readallst ('user','186884634')">读取所有数据</button></p></div>
   <div><p><button @click="del ('user','186884634')">删除数据</button></p></div>
   <div><p><button @click="readAll ()">查看所有记录</button></p></div>
   <div><p><button @click="cProducts()">导入数据</button></p></div>
   <div><p><button @click="update('registeredtip','id')">导入数据tip</button></p></div>
   <p> <button @click="imageUrlToBase64('https://hujiakj.oss-cn-shanghai.aliyuncs.com/167906181318710765.png')">图片转数据流</button></p>
   <p> <button @click="gp2()">图片转数据流测试2</button></p>
   <div>{{rs}}-{{ dat }}</div>
   <img :src="msg" width="100" height="100"/>

   </div> -->
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      dataURL:null,
      //本地数据库名
      mydbname:'tts',
      //本地数据库版本
      myversion:1,
      myApiBase: this.$api.apiBase,
     // myApiBase:'http://192.168.31.178:10100/',
      msg:'',
      rs:[],
      dat:[],
      message:[],
      pics:[],
      uid:'',
      storeId:''
    }
  },

  created() {
  this.getpid();
  },

  async mounted() {
           if (navigator.onLine) {

             this.cAllStorePermissionsList();
             this.cStoreItem();
             this.cRegistered_tip();
             this.ctypeList();

             if(this.uid && this.storeId){
             this.myTypeList();
             this.ProductsAll();
            }
            else{
              this.$router.push({
              path: '/login'
              })
            }

          }
      },

  methods:{

    async getpid(){
        this.uid= parseInt(localStorage.getItem('id'));
        this.storeId= parseInt(localStorage.getItem('storeId'));
        var ust=await this.getindex ('store','userId',this.uid);
        if(ust==''){
          this.$router.push({
            path: '/login'
          })
        }
     },

   //初始化数据库
   conn () {
      return new Promise((resolve, reject) => {
        const connection = window.indexedDB.open(this.mydbname, this.myversion)
        connection.onsuccess = function (event) {
          resolve(event.target.result)
        }

      })
    },

  //封装 新增, 读取, 读取所有 方法
  async addget (st,type,data) {

    let typeList = ['add', 'get', 'getAll']
    if (!typeList.includes(type)) {
      throw new Error(`操作类型错误, 仅支持: ${typeList.toString()} 方法`)
    }
    const readType = type === 'add' ? 'readwrite' : 'readonly'

    const res = await this.conn()
    const objectStore = res.transaction(st, readType).objectStore(st)
    const response = new Promise((resolve, reject) => {
      const request = objectStore[type](data)
      request.onsuccess = (res) => {
        resolve(res.target.result)
      }
      request.onerror = (err) => {
        reject(err)
      }
    })
    return response
  },


    //更新数据
    update(st,dat){
      const conn = window.indexedDB.open(this.mydbname,this.myversion);
      conn.onsuccess = function (event) {
        var db = event.target.result;
          var request = db.transaction([st], 'readwrite').objectStore(st)
          .put(dat);

        request.onsuccess = function (event) {
        //  console.log('products更新成功');
        };

        request.onerror = function (event) {
         // console.log('products更新失败');
        }
        }
    },

    //读取索引方法
  async getindex (st,index,data)  {
        const res = await this.conn()
        const objectStore = res.transaction(st,'readwrite').objectStore(st)
        const response = new Promise((resolve, reject) => {
          const request = objectStore.index(index).getAll(data);
          request.onsuccess = (res) => {
            resolve(res.target.result)
          }
          request.onerror = (err) => {
            reject(err)
          }
        })
        return response
        },

    async delindex (st,data)  {

        const res = await this.conn()
        const objectStore = res.transaction(st,'readwrite').objectStore(st)
        const response = new Promise((resolve, reject) => {
          const request = objectStore.delete(data);
          request.onsuccess = (res) => {
            resolve(res.target.result)
          }
          request.onerror = (err) => {
            reject(err)
          }
        })
        return response
    },

    async delindexall(st,index,data){
         Array.rs=await this.getindex (st,index,data);
         Array.rs.forEach((v,i) => {
          this.delindex (st,v.id);

          });
    },



    async cAllStorePermissionsList(){
      var that=this;
      await axios.get(this.myApiBase+'/StorePower/getAllStorePermissionsList')
      .then(res=>{
      Array.rs=res.data.data;
      if(Array.rs){

        Array.rs.forEach((v,i) => {
          that.update('allStorePermissionsList',v);
          });

      }
      })
    },

      async ctypeList(){
      var that=this;
      await axios.get(this.myApiBase+'/store/getPlatformProductType')
      .then(res=>{
      Array.rs=res.data.typeList;
      Array.rs.forEach((v,i) => {
          that.update('typeList',v);
          });
      })
    },

//加载产品分类表
    async myTypeList(){

      var that=this;
       var uid=localStorage.getItem('id');

          let da = new FormData();
          da.append('id',uid);
          da.append('pageNum',1);
          da.append('pageSize',20);
          await axios.post(that.myApiBase+'/user/getMyTypeList',da)
          .then(res=>{
           // console.log(res);
           Array.rs=res.data.tTypeList;
           Array.rs.forEach((v,i) => {
               that.update('myTypeList',v);
               });
          })

    },

    async cStoreItem(){
      var that=this;
      await axios.get(this.myApiBase+'/StorePower/getStoreItem?storeId=0')
      .then(res=>{
      Array.rs=res.data.data;
      Array.rs.forEach((v,i) => {
          that.update('storeItem',v);
          });
      })
    },
    async cRegistered_tip(){
      var that=this;
      let da = new FormData();
      da.append('type',1);
      await axios.post(this.myApiBase+'/user/getRegisteredTip',da)
      .then(res=>{
      that.update('registered_tip',{id:1,content:res.data.data.content,createTime:res.data.data.create_time});
      })
    },

    async delProductsAllchek(){
      var that=this;

       /*
      let animals = [{name: "dog"}, {name: "horse"}, {name: "cat"}];
      let element = {name: "cat"}
      var va=animals.some(animal => animal.name === element.name);
      */
     /*
      let animals = [“cat”, “dog”, “pig”, “deer”]
      animals.includes(“deer”) // true
      animals.includes(“horse”) // false
        */
        /*
        var a = [1,2,3,4,5];  //定义数组
        var s = a.join("==");  //指定分隔符
        console.log(s);  //返回字符串“1==2==3==4==5”
        */

      let da = new FormData();
      da.append('id',that.storeId);
      da.append('keywords','');
      da.append('pageNum',1);
      da.append('pageSize',9999);
      let pids="";
      await axios.post(that.myApiBase+'/store/search2',da)
      .then(res=>{
      let rs=res.data.productList;

      if(rs){
            rs.forEach(async (v,i) => {
              if(i==0){
                pids=v.productId;
              }else{
                pids=pids+","+v.productId;
              }

            });
          }

      });

      let rs1= await that.addget('productsAll','getAll');
    //  console.log('rs1',rs1);
          rs1.forEach(async (v,i) => {
           var pin=pids.includes(v.id);
           if(!pin){
            //  console.log('no',v.id);
              that.delindex('productsAll',v.id);
              that.delindexall('pImgFiles','productId',v.id);
              that.delindexall('pAreaImgFiles','productId',v.id);
           }
       });

    },

// 所有产品，批量更新产品记录(若该记录不存在则新增)

async ProductsAll(){

      var that=this;

      var upok=localStorage.getItem('up');

        if(upok != 'ok')
        {
          return;
        }

      that.delProductsAllchek();

      let da = new FormData();

      da.append('id',that.storeId);
      da.append('keywords','');
      da.append('pageNum',1);
      da.append('pageSize',9999);
      await axios.post(this.myApiBase+'/store/search2', da)
      .then(res=>{
      Array.rs=res.data.productList;
      if(Array.rs){
          Array.rs.forEach(async (v,i) => {
              if(v.productName){
                var g= await this.addget('productsAll','get',v.productId);

                if(g){

                    var vp=v.productVersion;
                    var gp=g.productVersion;

                    if(vp>gp)
                      {
                      await that.delindexall('pImgFiles','productId',g.id);
                      await that.delindexall('pAreaImgFiles','productId',g.id);
                      that.producttxt(v.productId);
                      that.pImgFiles(v.productId);
                      that.pAreaImgFiles(v.productId);
                      that.productCover(v.productId);
                    }
                }
                else{
                      var g1= await this.addget('productsAll','getAll');

                      if(g1.length){
                        that.producttxt(v.productId);
                        that.pImgFiles(v.productId);
                        that.pAreaImgFiles(v.productId);
                        that.productCover(v.productId);
                      }

                }
              }
              else{
              // console.log(v.productName);
              }

              });
        }

      //  console.log('s',Array.rs)

      })
    },

   //产品浏览文字详情
   async producttxt(pid){
      var that=this;
      let da = new FormData();
      da.append('productId',pid);

      await axios.post(this.myApiBase+'/product/getProductDetail',da)
      .then(async res=>{

        Array.rs=res.data.tProduct;
        Array.rs.productId=res.data.tProduct.id;

        var tname=res.data.tProduct.productTypeName;

        if(!tname){Array.rs.productTypeName='无类别';}

        that.update('productsAll', Array.rs);

      })
    },

    //产品详情图片
   async pImgFiles(pid){
      var that=this;
      let da = new FormData();
      da.append('productId',pid);

      await axios.post(this.myApiBase+'/product/getProductDetail',da)
      .then(async res=>{

        var rs=res.data.tProduct.productImgs;

        const chars = rs.split(',');

        chars.forEach(async (v,i) => {


           var pic =await that.imageUrlToBase64(v);
                    var rs={
                          "id":pid+'_'+i,
                         "productId":pid,
                         "imgFiles":pic,
                         "url":'',
                        };
                    that.update('pImgFiles',rs);
                });
      })

    },

 //库位图片
 async pAreaImgFiles(pid){
      var that=this;
      let da = new FormData();
      da.append('productId',pid);

      await axios.post(this.myApiBase+'/product/getProductDetail',da)
      .then(async res=>{

        var rs=res.data.tProduct.productAreaImg;
        if(rs){
        const chars = rs.split(',');
        chars.forEach(async (v,i) => {

           var pic =await that.imageUrlToBase64(v);
                    var rs={
                          "id":pid+'_'+i,
                         "productId":pid,
                         "imgFiles":pic,
                         "url":'',
                        };
                    that.update('pAreaImgFiles',rs);
                });
          }
      })

    },

 //封面图片
 async productCover(pid){
      var that=this;
      let da = new FormData();
      da.append('productId',pid);

      await axios.post(this.myApiBase+'/product/getProductDetail',da)
      .then(async res=>{

        var productCover=res.data.tProduct.productCover;

       // console.log('productCover',productCover);

        var pic =await that.imageUrlToBase64(productCover);
                    var rs={
                          "id":pid,
                         "productId":pid,
                         "imgFiles":pic,
                        };
           that.update('productCover',rs);


      })

    },

      //图片转Base64
      async imageUrlToBase64(imageUrl) {
          var img64;
          var that=this;

          var promise = new Promise((res) => {
            let image = new Image() // 一定要设置为let，不然图片不显示
            image.setAttribute('crossOrigin', 'anonymous') // 解决跨域问题
            //image.src = imageUrl +"&v=" + Math.random() // 如果是本地图片替换为 image.src = imageUrl
            image.src = imageUrl // 如果是本地图片替换为 image.src = imageUrl



            image.onload = () => {
              var canvas = document.createElement("canvas")
              canvas.width = image.width
              canvas.height = image.height
              var context = canvas.getContext('2d')
              context.drawImage(image, 0, 0, image.width, image.height)
              var quality = 0.8
              var dataURL = canvas.toDataURL("image/jpeg", quality) // 使用toDataUrl将图片转换成jpeg的格式,不要把图片压缩成png，因为压缩成png后base64的字符串可能比不转换前的长！
              img64 = dataURL;
              res(img64)
            }
          });

          await promise;
          return img64;
        },

  },

};
</script>



// WEBPACK FOOTER //
// src/pages/nonet/nonet.vue